import React from 'react';
import PropTypes from 'prop-types';
import PartnerFundingSources from 'components/partner-funding-sources/PartnerFundingSources';
import PartnerFundingSourceBriefDetailsModal from 'components/partner-funding-sources/PartnerFundingSourceBriefDetailsModal';

export default function PartnerFundingSourcesTab({ partnerId }) {
  return (
    <>
      <PartnerFundingSources preFilterByPartner={true} partnerId={partnerId} />
      <PartnerFundingSourceBriefDetailsModal />
    </>
  );
}

PartnerFundingSourcesTab.propTypes = {
  partnerId: PropTypes.string.isRequired,
};
